<template>
<v-app>
  <v-main>
      <v-container fluid ma-0 pa-0 fill-height style="overflow: hidden">
        <v-layout row>
          <v-flex class="box" id="leftBackground" xs0 sm5 md7>
            <img id="ResetvacationImage" style="float: left; margin-top: 103px; margin-left: 67px" src="@/assets/i-vacation.png" />       
          </v-flex>
          <v-flex id="rightForm" class="box" xs12 sm7 md5 px-md-10>
                <v-form ref="form" >
         <v-container id="formContainer">
            <v-col style="margin-top: 140px; margin-bottom: 20px"  cols="12" id="loginHeader">
               <h1 style="text-align: center; font-size: 40px; font-weight: bold">{{ $t("login_forgot_password") }}</h1>
               <div style="text-align: center; font-size: 14px; margin-top: 08px">{{ $t("forgot_password_description") }}</div>
            </v-col>
            <v-col cols="12">
               <v-text-field :placeholder='$t("web_reset_password_email")' @blur="validateForm" v-on:keydown.enter.prevent='validateForm'  @keydown.enter= "validateForm"  single-line append-icon="mdi-lock-outline" v-model="$v.email.$model"></v-text-field>
            </v-col>
            <v-col cols="12" class="mt-n4">
               <div style="height: 10px">
                    <ul id="listMessage">
                  <li style="text-align: center" v-for="item in errors" :key="item">
                     {{ item}}
                  </li>
               </ul>
               </div>
                
            </v-col>
            <v-col cols="12" class="mt-14">
               <v-btn id="btnLogin" v-on:click="handleResetPassword">{{ $t("forgot_password_title") }}</v-btn>
            </v-col>
            <v-col cols="12" class="mb-8 mt-n4">
              <div class="backLogin">
                <div class="back">
                  <button id="btnBack" style="color: #C7C7C7" @click="movetoLogin"><v-icon size="25" style="color: #C7C7C7" left>mdi-keyboard-backspace</v-icon>{{ $t("web_back") }}</button>
                </div>
              </div>       
            </v-col>
         </v-container>
        </v-form>
          </v-flex>
        </v-layout>
      </v-container>
  </v-main>
</v-app>
</template>

<script>
    import { required, email } from "vuelidate/lib/validators";
    import { mapGetters } from "vuex";
    import { ListEvents } from "@/utilities/CommonUtilities";
    export default {
      validations: {
          email: { required, email }
        },
        data () {
            return {
                isRemember: false,
                email: "",
                password: "",
                apiErrorOccurred: null,
                label: this.$i18n.t('common_unknown_error'),
                errors:[],
            }
        },
        methods: {
            async handleResetPassword() {
              this.$v.$touch();
              if (this.$v.$invalid) {
                this.validateForm();
                return;
              }
              this.notifyBus.$emit(ListEvents.showLoadingIndicator);
              let params = {
                  'emailAddress': this.email.toLowerCase(),};
              try {
                await this.dataSource.deleteData(this.dataSource.changePasswordURL, params);
               this.notifyBus.$emit(ListEvents.hideLoadingIndicator);
               this.notifyBus.$emit(ListEvents.showOKDialog, this.$t("forgot_password_success_msg"));
              } catch(ex) {
                 this.apiErrorOccurred = null;
                 if (ex.response.status == 404) {
                   this.notifyBus.$emit(
                   ListEvents.showOKDialog,
                   this.$i18n.t("forgot_email_not_exist_msg")
                );
                } else {
                   this.notifyBus.$emit(
                   ListEvents.showOKDialog,
                   this.$i18n.t("common_unknown_error")
                );
              }
                 return;
              }finally {
                this.notifyBus.$emit(ListEvents.hideLoadingIndicator);
              }

              this.$router.push({name: "home"});
            },
            handleError() {
                this.apiErrorOccurred = this.$i18n.t('common_unknown_error');
            },
            movetoLogin() {
             this.$router.push('/login');
            },
            validateForm(){
              if (this.$v.$invalid) {
               if(this.errorList.length > 0 || this.errorList.length > 0) {
                 this.errors = this.errorList
               }else{
                 this.errors = []
               }
              }else{
                this.errors = []
              }
             },
             
        },
        computed: {
            ...mapGetters(["credentialInfo"]),
            emailErrors () {
              const errors = []
              if (!this.$v.email.$dirty) return errors
              !this.$v.email.email && errors.push( this.$i18n.t('forgot_email_format_incorrect'))
              !this.$v.email.required && errors.push( this.$i18n.t('login_email_empty_msg'))
              return errors
            },
            errorList() {
              if(this.emailErrors.length > 0) {
                return [...this.emailErrors];
              } else if(this.apiErrorOccurred != null) {
                return [this.apiErrorOccurred];
              } else return [];
            }
        },
        watch:{
          email() {
            this.apiErrorOccurred = null;
          },
          password() {
            this.apiErrorOccurred = null;
          }
        },
        created() {
            this.notifyBus.$on("httpError", this.handleError);
        },
        inject: ["dataSource", "notifyBus"],
    }
</script>
<style scoped>
#checkBox{
  margin-top: -0.51px
}
#myField{
  border-color: #6fbd44;
}
.divider {
  margin-top: 63px;
  margin-right: 10px;
  padding-bottom: 4px
}
hr.solid {
  border-top: 3px solid #bbb;
}
 #loginHeader{
  margin-top: 80px;
  text-align: start
 }
 h1{
  font-size: 40px
 }
 #rightForm{
  width: 100%;
  height: 100%;
  background-image: url('../../assets/background_login1.png');
  -webkit-background-size: contain;
  -moz-background-size: contain;
  -o-background-size: cover;
  background-size: cover;
 }
 #btnLogin{
  background-color: #f1bd42;
  width: 100%;
  height: 100%;
  font-size: 18px;
  color: white;
  height: 50px;
  font: bold;
  font-weight: 800;
  opacity: 1;
  padding-top: 15px;
  padding-bottom: 15px
 }
 #textCannotLogin{
  color: grey;
  font-size: 14px;
  text-decoration: underline
 }
hr.solid {
  border-top: 0.1px solid grey;
  margin-top: 100px
}
#leftBackground{
  background: url('../../assets/background_login2.png');
  -webkit-background-size: contain;
  -moz-background-size: contain;
  -o-background-size: contain;
  background-size:cover;
  margin-top: -15px;
  width: 100%;
}
a{
  padding:1em;
  text-align: center;
  display:inline-block;
  text-decoration: none !important;
  margin:0 auto;
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -ms-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
   transition: all 0.2s ease-in-out;
   color: grey;
}
#listMessage{
  list-style-type: none;
  width: 100%;
  margin: auto;
  color: red;
  text-align: center
}

.container{
  width: 100%;
  text-align: center;
}

li{
  size: 1px;
  text-align: center;
  white-space: nowrap;
}

@media screen and (max-width: 1500px) {
  #formContainer{ 
   padding: 30px;
}
}
@media screen and (max-width: 960px) {
  #ResetvacationImage{ 
   height: 80px;
   width: 200px;
}}
@media screen and (max-width: 600px) {
  #leftBackground{
    display: none
  }
}
#LanguageCol{
  margin-top: -100px
}
.v-application ul{
  padding-left: 0px
}
label{
  left: 0;
  right: 0;
  position: absolute;
  padding-left: 70px;
  text-align: center
}
.backLogin {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 40px;
  padding-right: 30px
}

.backLogin .back {
  display: flex;
  flex-direction: column;
}
#btnBack:focus {outline:0;}
</style>
